<template>
  <div class="twoDimensional">
    <div class="content">
      <ul class="ul">
        <li class="li" v-for="(item, index) in imgList" :key="index">
          <div class="img">
            <img :src="item.img" alt="" />
            <div class="layer">
              {{ item.desc }}
            </div>
          </div>
          <!-- <div class="name">
            {{ item.name }}
          </div> -->
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'twoDimensional',
  data() {
    return {
      imgList: [
        {
          img: require('./img/towd_1.jpg'),
          name: '设计地图',
          desc: '个性化地图主题设计，根据不同需求突显不同重点数据以适应不同的需求。'
        },
        {
          img: require('./img/towd_2.jpg'),
          name: '手绘地图',
          desc: '外表美观、对视觉有一定冲击力，成本低，风险低。'
        },
        {
          img: require('./img/towd_3.jpg'),
          name: '手绘地图',
          desc: '外表美观、对视觉有一定冲击力，成本低，风险低。'
        },
        {
          img: require('./img/towd_6.jpg'),
          name: '手绘地图',
          desc: '外表美观、对视觉有一定冲击力，成本低，风险低。'
        },
        {
          img: require('./img/towd_5.jpg'),
          name: '手绘地图',
          desc: '外表美观、对视觉有一定冲击力，成本低，风险低。'
        }
      ]
    };
  },
  computed: {},
  watch: {},
  methods: {},
  mounted() {}
};
</script>

<style scoped lang="scss">
@import url('~@/icons/pingfang/font.css');
.twoDimensional {
  .content {
    width: 100%;
    min-height: 950px;
    background: #ffffff;
    margin: 0 auto;
    // border: 1px solid #979797;
    .ul {
      display: flex;
      flex-wrap: wrap;
      box-sizing: border-box;
      min-height: 850px;
      padding: 45px 200px 0 240px;
      // justify-content: space-between;
      .li {
        margin-top: 45px;
        margin-right: 75px;
        text-align: center;
        .img {
          width: 416px;
          height: 234px;
          position: relative;
          overflow: hidden;
          cursor: pointer;
          img {
            width: 100%;
            height: 100%;
          }
          .layer {
            position: absolute;
            left: 0;
            bottom: -165px;
            width: 100%;
            height: 165px;
            transition: 0.5s;
            background: rgba(0, 0, 0, 0.6);
            color: #fff;
            font-family: 'PingFang';
            font-size: 22px;
            line-height: 30px;
            box-sizing: border-box;
            padding: 23px 58px 0 39px;
            text-align: left;
          }
        }
        .name {
          margin-top: 18px;
          font-size: 26px;
          font-family: 'PingFang';
          font-weight: bold;
          color: #000000;
        }
        // &:hover {
        //   .img {
        //     .layer {
        //       bottom: 0;
        //     }
        //   }
        // }
      }
    }
  }
}
</style>
